import React from 'react';
import { Table } from 'antd';
import { useReadyToPack } from '../../hooks/useStudioOps';

export default function ReadyToPack() {
    const { data, isFetching } = useReadyToPack();
    return (
        <div style={{ padding: 16 }}>
            <Table
                loading={isFetching}
                rowKey="companyCode"
                dataSource={data?.data?.data || []}
                columns={[
                    { title: 'Client', dataIndex: 'companyCode' },
                    { title: 'Ready', dataIndex: 'count' },
                    { title: '0-2d', dataIndex: 'age0to2' },
                    { title: '3-5d', dataIndex: 'age3to5' },
                    { title: '>5d', dataIndex: 'ageOver5' },
                    { title: 'Oldest', dataIndex: 'oldestAt' },
                ]}
            />
        </div>
    );
}
